import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { LoadingOutlined } from '@ant-design/icons'
import { message as antMessage } from 'antd'
import { inject, observer } from 'mobx-react'
import { ListHistoryLogModalWrapper } from './ListHistoryLogModalStyled'
import common_history_log from '../../enum_utils'
import date_format from '../../date_format'
import DiffTable from './DiffTable/DiffTable'

const ListHistoryLogModal = props => {
  const {
    type,
    taskInfo,
    isVisible,
    handleCloseHistory,
    listHistoryLogStore,
  } = props

  const { list, isLoading, message: storeMessage } = listHistoryLogStore

  useEffect(() => {
    if (!taskInfo?.code) {
      return
    }

    listHistoryLogStore.getList(taskInfo.code)

    return () => {
      listHistoryLogStore.clear()
    }
  }, [taskInfo?.code, listHistoryLogStore])

  return (
    <ListHistoryLogModalWrapper
      title={'Lịch sử'}
      width={1300}
      style={{ top: 40 }}
      visible={isVisible}
      closable={true}
      maskClosable={true}
      onCancel={handleCloseHistory}
      footer={null}>
      <div>
        {isLoading && (
          <LoadingOutlined style={{ marginLeft: 10 }} spin={true} />
        )}

        {storeMessage && <p>{storeMessage}</p>}

        {!isLoading && list.length > 0 && (
          <ul>
            {list.map(item => (
              <li key={item.id} style={{ marginBottom: 16 }}>
                <span style={{ marginBottom: 8, display: 'block' }}>
                  <b>{common_history_log.enumToText(item.action)}</b> lúc
                  <span>
                    {' '}
                    {date_format.HH_mm_DD_MM_YYYY(item.processed_date)}
                  </span>{' '}
                  bởi
                  <b> {item.user.name_uppercase}</b>
                </span>
                <DiffTable
                  dataBefore={item.data_before}
                  dataAfter={item.data_after}
                  type={type}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </ListHistoryLogModalWrapper>
  )
}

ListHistoryLogModal.propTypes = {
  type: PropTypes.string,
  isVisible: PropTypes.bool,
  handleCloseHistory: PropTypes.func,
  taskInfo: PropTypes.any,
}

export default inject('listHistoryLogStore')(observer(ListHistoryLogModal))
